import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCookie } from './commonUtils/cookie.helper.js';

function ProtectedRoutes() {
  const token = getCookie("authToken");
  const isAuthorized = (token) ? true : false;

  useEffect(() => {
    if (!isAuthorized) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [isAuthorized]);

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return (
    <>
      {isAuthorized ? (
        <Outlet />
      ) : (
        <Navigate to="/" />
      )}
    </>
  );
}

export default ProtectedRoutes;